<template>
  <div class="field">
    <label :class="isFieldRequired ? 'req' : ''">{{ label }}</label>
    <p class="field_description" v-if="description">{{ description }}</p>
    <input
        :disabled="isDataUpdated"
        :class="isFieldHasError ? 'has_errors':''"
        name="name"
        type="text"
        :value="modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @change="onChange"
    />
  </div>
</template>

<script>
export default {
  name: "BaseInput2.vue",
  data() {
    return {
    }
  },
  mounted() {
    //this.currentValue = this.value;
  },
  props: {
    'label': {},
    'modelValue': {},
    'description': {},
    'rules': {},
    'objectKey': {},//Нужен для валидации
    'isFormSubmitted': {},
    'isDataUpdated': {},
		'isRequired': {default: false}
  },
  methods: {
	  onChange(val) {
      this.$emit('onChange', val);
      if (typeof this.$parent.saveData === 'function') {
        this.$parent.saveData();
      }
	  }
  },
  computed: {
    isFieldRequired() {
      if (typeof this.$parent.isFieldRequired === 'function') {
        return this.$parent.isFieldRequired(this.objectKey);
      } else {
        return this.isRequired;
      }
    },
    isFieldHasError() {
      return !!(this.isFieldRequired && this.isFormSubmitted && (this.modelValue === undefined || this.modelValue === null || this.modelValue?.length === 0));
    }
  }

}
</script>

<style scoped>

</style>